import React from 'react';
import { BillingPreviewUser } from '../../types/adminInvoice';

interface InvoiceUserDetailsProps {
  user: BillingPreviewUser;
  onClear: () => void;
}

const InvoiceUserDetails: React.FC<InvoiceUserDetailsProps> = ({ user, onClear }) => (
  <div className="mb-6 p-4 bg-gray-50 border border-gray-200 rounded-lg">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-sm">
        <div>
          <span className="text-gray-500">Name</span>
          <p className="font-medium text-gray-900">{user.full_name}</p>
        </div>
        <div>
          <span className="text-gray-500">Username</span>
          <p className="font-medium text-gray-900">{user.username}</p>
        </div>
        <div>
          <span className="text-gray-500">Email</span>
          <p className="font-medium text-gray-900">{user.email}</p>
        </div>
        <div>
          <span className="text-gray-500">Team</span>
          <p className="font-medium text-gray-900">
            {user.team_name || '—'}
            {user.team_id != null && (
              <span className="ml-1 text-xs text-gray-400">(ID: {user.team_id})</span>
            )}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onClear}
        className="text-sm text-blue-600 hover:text-blue-800 underline shrink-0"
      >
        Clear selection
      </button>
    </div>
  </div>
);

export default InvoiceUserDetails;
